import React from "react";
import { Button, ButtonGroup, Form, InputGroup } from "react-bootstrap";
import { useFormikContext } from "formik";
import i18n from "i18next";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

const MultiLanguageInputText = ({
  label,
  name,
  required = false,
  hint = "",
  languages,
  onVisibleValueChange = null,
  ...rest
}) => {
  const [selectedLang, setSelectedLang] = React.useState(i18n.language);
  const { values, setFieldValue, errors, touched } = useFormikContext();
  const { t } = useTranslation("common");
  const safeValues = values || {};

  const getVisibleValue = (lang) => {
    let value_accessor = name + (lang != i18n.language ? "_" + lang : "");
    return safeValues[value_accessor] || "";
  };

  if (!languages) {
    return <></>;
  }

  function renderBorderGroup() {
    return (
      <ButtonGroup>
        {languages.map((lang, index) => (
          <Button
            onClick={() => {
              setSelectedLang(lang);
              onVisibleValueChange?.(getVisibleValue(lang));
            }}
            key={lang}
            variant={selectedLang === lang ? "primary" : "outline-primary"}
            className={classNames({
              "border-top-left-radius-0": index === 0,
              "border-bottom-left-radius-0": index === 0,
            })}
          >
            {lang}
          </Button>
        ))}
      </ButtonGroup>
    );
  }

  return (
    <Form.Group className="mb-3" controlId={name}>
      {selectedLang === i18n.language && (
        <>
          <Form.Label>
            {label} {required && "*"}
          </Form.Label>

          <InputGroup>
            <Form.Control
              name={name}
              value={safeValues[name] || ""}
              onChange={(e) => {
                setFieldValue(name, e.target.value);
                onVisibleValueChange?.(e.target.value);
              }}
              {...rest}
            />
            {renderBorderGroup()}
          </InputGroup>
          <Form.Text className="text-muted">{hint}</Form.Text>
          <div className="text-danger">
            {errors[`${name}`] && touched[`${name}`] && (
              <small className="text-danger">{errors[`${name}`]}</small>
            )}
          </div>
        </>
      )}
      {selectedLang !== i18n.language && (
        <>
          <Form.Label>
            {label} ({t(`general.languages.${selectedLang}`)}) {required && "*"}
          </Form.Label>
          <InputGroup>
            <Form.Control
              name={`${name}_${selectedLang}`}
              value={safeValues[`${name}_${selectedLang}`] || ""}
              onChange={(e) => {
                setFieldValue(`${name}_${selectedLang}`, e.target.value);
                onVisibleValueChange?.(e.target.value);
              }}
              {...rest}
            />
            {renderBorderGroup()}
          </InputGroup>
          <Form.Text className="text-muted">{hint}</Form.Text>
          {touched[`${name}_${selectedLang}`] &&
            errors[`${name}_${selectedLang}`] && (
              <small className="text-danger">
                {errors[`${name}_${selectedLang}`]}
              </small>
            )}
        </>
      )}
    </Form.Group>
  );
};

export default MultiLanguageInputText;
